import axios from 'axios';
import routes from './routes';

export const sendMessage = params => (
  axios.post(routes.contato.sendMessage(), params)
);



// WEBPACK FOOTER //
// ./src/services/contato.js